import { Component, Inject, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { ToastContainerComponent } from './shared/components/toast-container.component';
import { LayoutService } from './core/util/services/layout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, ToastContainerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('portal-retail-frontend');

  protected _layout = inject(LayoutService);
  protected _auth = inject(AuthService);

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly translate: TranslateService,
  ) {
    this.translate.addLangs(['pt-br', 'en']);
    this.translate.setDefaultLang('pt-br');
    const browserLang = this.translate.getBrowserLang();
    const lang = browserLang?.match(/en|pt-br/) ? browserLang : 'pt-br';
    this.setLang(lang);
    this.translate.onLangChange.subscribe((event) => {
      // Only update the document lang attribute, do not call setLang again!
      this.document.documentElement.lang = event.lang;
      // Optionally, update state or log, but DO NOT call this.setLang(event.lang)
    });
  }

  setLang(lang: string) {
    this.document.documentElement.lang = lang;
    this.translate.use(lang);
    console.log('lang', lang);
  }
}
